import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CourseQuizService } from '../../../../api/Services/maintenance/course-quiz.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '../../../../system/auth.service';
 
import { MatRadioChange } from '@angular/material/radio';
import { DialogService } from '../../../../common/dialog.service';

@Component({
  selector: 'app-courses-quiz-create-question',
  templateUrl: './courses-quiz-create-question.component.html',
  styleUrls: ['./courses-quiz-create-question.component.css']
})
export class CoursesQuizCreateQuestionComponent implements OnInit {

  Form: FormGroup;
  parameters: any[];
  default_coqu_in_quiz_type:number;
  coquti_bi_id:string;
  constructor(
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private courseQuizServices: CourseQuizService,
    private authService : AuthService,
    private dialogService: DialogService,
    public dialogRef: MatDialogRef<CoursesQuizCreateQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { 
    this.coquti_bi_id = data;
  }

  ngOnInit(): void {
   this.default_coqu_in_quiz_type = 1;
    this.loadInitial();
  }

  public loadInitial() {
    this.initForm();
    this.parameters = this.authService.getParameters();
  }
  initForm() {
    
    this.Form = this.formBuilder.group({
      coqu_tx_description: [null, Validators.required],
      coqu_in_quiz_type: [null, Validators.required],
      coquti_bi_id: [null, Validators.required]
    });
  }

  SaveQuizQuestion(){

    this.Form.controls['coqu_in_quiz_type'].setValue(this.default_coqu_in_quiz_type);
    this.Form.controls['coquti_bi_id'].setValue(this.coquti_bi_id);
    if (this.Form.valid) {
      this.dialogService.openConfirmDialog('¿Seguro de guardar este registro?')
      .afterClosed().subscribe(res => {
        this.courseQuizServices.InsertQuiz(this.Form.getRawValue()).subscribe(
          data => {
            console.log(data);

            if (data['sucess']) {
            
              this.toastr.success(data['msg'], 'Correcto');
             
            }
            else {
              this.toastr.warning(data['msg'], 'Advertencia');
            }
            this.dialogRef.close();
          }
        );

      });
    }
    else{
      this.toastr.warning('Por favor complete los datos del formulario.', 'Advertencia');
    }
    
  }

  Change_coqu_in_quiz_type(event: MatRadioChange){
    this.default_coqu_in_quiz_type = event.value;
  }
}
